import { API_URLS } from '@/constants/api-urls.constants';
import { HttpService } from '@/services/http/http.service';
import { ReportData } from '@/types/request.types';
import {
  GetConsent,
  PatientInfo,
  ReportAlerts,
  ReportFlow,
  ReportHasAlerts
} from '@/types/response.types';

export const getPatientInfo = async (token: string): Promise<PatientInfo> => {
  return await HttpService.get<PatientInfo>({
    url: API_URLS.PATIENT_INFO,
    token
  });
};

export const getReportFlow = async (locale: string): Promise<ReportFlow> => {
  return await HttpService.get<ReportFlow>({
    url: API_URLS.REPORT_FLOW(locale)
  });
};

export const getConsent = async (): Promise<GetConsent> => {
  return await HttpService.get<GetConsent>({
    url: API_URLS.CONSENT
  });
};

export const getReportHasAlerts = async (): Promise<ReportHasAlerts> => {
  return await HttpService.get<ReportHasAlerts>({
    url: API_URLS.REPORT_ALERTS
  });
};

export const login = async (token: string, dob: string) => {
  return await HttpService.post({
    token,
    url: API_URLS.LOGIN,
    data: {
      dob
    }
  });
};

export const postReport = async (report: ReportData): Promise<ReportAlerts> => {
  return await HttpService.post<ReportAlerts>({
    url: API_URLS.REPORT,
    data: report
  });
};
